import React from 'react';

/**
 * Section 4 : Logement et environnement
 */
const AssessmentSection4_Logement = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange('housing', {
      ...data,
      [field]: value
    });
  };

  const handleNestedChange = (category, field, value) => {
    onChange('housing', {
      ...data,
      [category]: {
        ...data[category],
        [field]: value
      }
    });
  };

  const handleArrayToggle = (field, value) => {
    const currentArray = data?.[field] || [];
    const newArray = currentArray.includes(value)
      ? currentArray.filter(item => item !== value)
      : [...currentArray, value];
    handleChange(field, newArray);
  };

  return (
    <div className="assessment-section-content">
      <h3 className="assessment-section-title">LOGEMENT ET ENVIRONNEMENT</h3>

      <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '16px' }}>
        Caractéristiques du logement
      </h4>

      <div className="assessment-grid-2">
        <div className="assessment-form-group">
          <label>Type de logement</label>
          <select
            className="assessment-form-control"
            value={data?.type || ''}
            onChange={(e) => handleChange('type', e.target.value)}
          >
            <option value="">-- Sélectionner --</option>
            <option value="maison">Maison individuelle</option>
            <option value="appartement">Appartement</option>
            <option value="residence">Résidence avec services</option>
            <option value="autre">Autre</option>
          </select>
        </div>

        <div className="assessment-form-group">
          <label>Statut d'occupation</label>
          <select
            className="assessment-form-control"
            value={data?.status || ''}
            onChange={(e) => handleChange('status', e.target.value)}
          >
            <option value="">-- Sélectionner --</option>
            <option value="proprietaire">Propriétaire</option>
            <option value="locataire">Locataire</option>
            <option value="heberge">Hébergé(e) chez un proche</option>
            <option value="autre">Autre</option>
          </select>
        </div>
      </div>

      <div className="assessment-grid-2">
        <div className="assessment-form-group">
          <label>Étage (si appartement)</label>
          <input
            type="number"
            min="0"
            className="assessment-form-control"
            value={data?.floor || ''}
            onChange={(e) => handleChange('floor', parseInt(e.target.value) || null)}
          />
        </div>

        <div className="assessment-form-group">
          <label>Ascenseur</label>
          <div className="assessment-radio-group">
            <label className="assessment-radio-label">
              <input
                type="radio"
                name="hasElevator"
                checked={data?.hasElevator === true}
                onChange={() => handleChange('hasElevator', true)}
              />
              <span>Oui</span>
            </label>
            <label className="assessment-radio-label">
              <input
                type="radio"
                name="hasElevator"
                checked={data?.hasElevator === false}
                onChange={() => handleChange('hasElevator', false)}
              />
              <span>Non</span>
            </label>
          </div>
        </div>
      </div>

      <div className="assessment-form-group">
        <label>Nombre de pièces</label>
        <input
          type="number"
          min="1"
          className="assessment-form-control"
          value={data?.numberOfRooms || ''}
          onChange={(e) => handleChange('numberOfRooms', parseInt(e.target.value) || null)}
        />
      </div>

      <div className="assessment-form-group">
        <label>Accès au logement</label>
        <select
          className="assessment-form-control"
          value={data?.access || ''}
          onChange={(e) => handleChange('access', e.target.value)}
        >
          <option value="">-- Sélectionner --</option>
          <option value="plain-pied">Plain-pied (pas de marches)</option>
          <option value="quelques-marches">Quelques marches</option>
          <option value="escaliers">Escaliers importants</option>
          <option value="rampe">Rampe d'accès</option>
        </select>
      </div>

      <div className="assessment-form-group">
        <label>Adaptations du logement</label>
        <div className="assessment-checkbox-group">
          {['Barres d\'appui', 'Siège de douche', 'Lit médicalisé', 'Déambulateur/Fauteuil roulant', 'Téléalarme', 'Aucune'].map(item => (
            <label key={item} className="assessment-checkbox-label">
              <input
                type="checkbox"
                checked={data?.adaptations?.includes(item) || false}
                onChange={() => handleArrayToggle('adaptations', item)}
              />
              <span>{item}</span>
            </label>
          ))}
        </div>
      </div>

      <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '32px', marginBottom: '16px' }}>
        Environnement et commodités
      </h4>

      <div className="assessment-grid">
        <div className="assessment-form-group">
          <label>Proximité des commerces</label>
          <select
            className="assessment-form-control"
            value={data?.proximity?.shops || ''}
            onChange={(e) => handleNestedChange('proximity', 'shops', e.target.value)}
          >
            <option value="">-- Sélectionner --</option>
            <option value="pied">À pied (&lt; 500m)</option>
            <option value="voiture">Accessible en voiture (&lt; 5km)</option>
            <option value="eloigne">Éloigné (&gt; 5km)</option>
          </select>
        </div>

        <div className="assessment-form-group">
          <label>Transports en commun</label>
          <select
            className="assessment-form-control"
            value={data?.proximity?.publicTransport || ''}
            onChange={(e) => handleNestedChange('proximity', 'publicTransport', e.target.value)}
          >
            <option value="">-- Sélectionner --</option>
            <option value="accessibles">Accessibles à proximité</option>
            <option value="eloignes">Éloignés</option>
            <option value="inexistants">Inexistants</option>
          </select>
        </div>

        <div className="assessment-form-group">
          <label>Médecin traitant</label>
          <select
            className="assessment-form-control"
            value={data?.proximity?.doctor || ''}
            onChange={(e) => handleNestedChange('proximity', 'doctor', e.target.value)}
          >
            <option value="">-- Sélectionner --</option>
            <option value="proximite">À proximité</option>
            <option value="eloigne">Éloigné</option>
            <option value="aucun">Pas de médecin traitant</option>
          </select>
        </div>
      </div>

      <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '32px', marginBottom: '16px' }}>
        Sécurité et confort
      </h4>

      <div className="assessment-form-group">
        <label>Le logement présente-t-il des risques identifiés ?</label>
        <div className="assessment-radio-group">
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="hasRisks"
              checked={data?.safety?.hasRisks === false}
              onChange={() => handleNestedChange('safety', 'hasRisks', false)}
            />
            <span>Non</span>
          </label>
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="hasRisks"
              checked={data?.safety?.hasRisks === true}
              onChange={() => handleNestedChange('safety', 'hasRisks', true)}
            />
            <span>Oui</span>
          </label>
        </div>
      </div>

      {data?.safety?.hasRisks && (
        <div className="assessment-form-group">
          <label>Précisez les risques</label>
          <textarea
            className="assessment-form-control"
            rows="3"
            value={data?.safety?.risksDescription || ''}
            onChange={(e) => handleNestedChange('safety', 'risksDescription', e.target.value)}
          />
        </div>
      )}

      <div className="assessment-form-group">
        <label>Animaux de compagnie</label>
        <div className="assessment-radio-group">
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="hasPets"
              checked={data?.pets?.hasPets === false}
              onChange={() => handleNestedChange('pets', 'hasPets', false)}
            />
            <span>Non</span>
          </label>
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="hasPets"
              checked={data?.pets?.hasPets === true}
              onChange={() => handleNestedChange('pets', 'hasPets', true)}
            />
            <span>Oui</span>
          </label>
        </div>
      </div>

      {data?.pets?.hasPets && (
        <div className="assessment-grid-2">
          <div className="assessment-form-group">
            <label>Type d'animal</label>
            <input
              type="text"
              className="assessment-form-control"
              placeholder="Ex: Chien, Chat"
              value={data?.pets?.type || ''}
              onChange={(e) => handleNestedChange('pets', 'type', e.target.value)}
            />
          </div>
          <div className="assessment-form-group">
            <label>Comportement</label>
            <select
              className="assessment-form-control"
              value={data?.pets?.behavior || ''}
              onChange={(e) => handleNestedChange('pets', 'behavior', e.target.value)}
            >
              <option value="">-- Sélectionner --</option>
              <option value="calme">Calme</option>
              <option value="agite">Parfois agité</option>
              <option value="agressif">Agressif</option>
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssessmentSection4_Logement;
